// extracted by mini-css-extract-plugin
export default {"modal":"paa-z","modalContent":"qaa-z","footer":"raa-z","cancelBtn":"saa-z","disabled":"taa-z","formWrapper":"uaa-z","fade":"vaa-z","fade-in":"waa-z","iframe":"xaa-z"};